import { takeEvery, put , call, select} from 'redux-saga/effects';
import { getApprovalList } from '../actions/ApprovalListActions';
import ApprovalService from "../services/ApprovalService";
import {enableSuccessToastInfo,enableRejectToastInfo,showApiErrorMessage} from "../actions/ToastActions";
import {createNewOrdersAnalyticsLog} from "../services/approval-util";
import {createAddonsAnalyticsLog} from "../services/approval-util-add-license";
import LoggerService from "../services/LoggerService";
import store from "../stores/store";
import * as _ from 'lodash';
import { ACTIVITY, ACTIVITY_CATEGORY } from '../constants/LogConstants';
import * as appConstants from '../constants/AppConstants';


const getSelectedTab = state => state.ApprovalListReducer.selectedTab;
const approvalListReducer = (state) => state.ApprovalListReducer;
const AppReducer = (state) => state.AppReducer;

export function* approveRequestSaga(){

    yield takeEvery('APPROVAL_REQUEST', function* (action){
        const selectedTab = yield select(getSelectedTab);
        const { approvalId } = action;
        yield call(approveRequestActionSaga,approvalId, selectedTab);
    })
        
}

export function* approveRequestActionSaga(approvalId, selectedTab){

    const approvalListProcessor = yield select(approvalListReducer);
    const AppReducerProcessor = yield select(AppReducer);
    const featureFlags = AppReducerProcessor.featureFlags;
    const approvalList = approvalListProcessor.approvalList;
    let selectedApproval = [];
    if(approvalList && approvalList.length > 0){
        selectedApproval = approvalList.filter((item) => item.approvalId === approvalId)
    }
    const flowId = selectedApproval[0] && selectedApproval[0].flowId ? selectedApproval[0].flowId : '';
    const userInfo = _.get(store.getState(), "AuthReducer.userInfo", {});
    try{
        const response = yield call(ApprovalService.approveRequest, approvalId);
        if (response.data) {
            //show toast message
            yield put(enableSuccessToastInfo(true));
            const messageObject = {};
            messageObject.Message = "Customer approved product/license request";
            messageObject.Functionality = ACTIVITY.APPROVE_REQUEST;
            messageObject.ActivityCategory = ACTIVITY_CATEGORY.ACTION;
            messageObject.Source_System = "Commerce";
            messageObject.Flow = "Product/License Approve";
            messageObject.Screen = "CustomerApprovalPortal";
            messageObject.AgentId = "";
            messageObject.CustomerGuid = _.has(userInfo, "userId") ? userInfo.userId : "";
            messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
            messageObject.approvalId = approvalId;
            messageObject.flowId = flowId;
            messageObject.Result = 'Success';
            LoggerService.saveSplunkLog(messageObject, 'info');
            let isAnalyticsFeatureEnabled = featureFlags.indexOf(appConstants.ENABLE_APPROVAL_ANALYTICS_LOG) > -1;

            if(isAnalyticsFeatureEnabled){
                if(selectedApproval[0] && selectedApproval[0].flowId === 'NEW_ORDERS'){
                    createNewOrdersAnalyticsLog(selectedApproval[0])
                }
                if(selectedApproval[0] && (selectedApproval[0].flowId === 'ADD_LICENSE' || selectedApproval[0].flowId === 'TEAM_CHANGE_PLAN')){
                    createAddonsAnalyticsLog(selectedApproval[0])
                }
            }
            yield put(getApprovalList(selectedTab));
        }
    }catch(error){
        const messageObject = {};
        messageObject.Message = "Customer approval of product/license request failed";
        messageObject.Functionality = ACTIVITY.APPROVE_REQUEST;
        messageObject.ActivityCategory = ACTIVITY_CATEGORY.ACTION;
        messageObject.Source_System = "Commerce";
        messageObject.Flow = "Product/License Approve";
        messageObject.Screen = "CustomerApprovalPortal";
        messageObject.AgentId = "";
        messageObject.CustomerGuid = _.has(userInfo, "userId") ? userInfo.userId : "";
        messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
        messageObject.approvalId = approvalId;
        messageObject.flowId = flowId;
        messageObject.errorMessage = error && error.message ? error.message : '';
        messageObject.Result = 'Failure';
        LoggerService.saveSplunkLog(messageObject, 'error');
        yield put(showApiErrorMessage(true));
    }

}

export function* rejectRequestSaga(){

    yield takeEvery('REJECT_REQUEST', function* (action){
        const selectedTab = yield select(getSelectedTab);
        const { approvalId } = action;
        yield call(rejectRequestActionSaga,approvalId, selectedTab);
    })
        
}

export function* rejectRequestActionSaga(approvalId, selectedTab){
    const state = store.getState();
    const selectedReason = _.get(state, "ApproveRejectReducer.selectedReason", '');
    const userInfo = _.get(state, "AuthReducer.userInfo", {});
    try{
        const response = yield call(ApprovalService.rejectRequest, approvalId);
        if (response.data) {
           //show toast message
           yield put(enableRejectToastInfo(true));
           const messageObject = {};
           messageObject.Message = "Customer rejected product/license request";
           messageObject.Functionality = ACTIVITY.REJECT_REQUEST;
           messageObject.ActivityCategory = ACTIVITY_CATEGORY.ACTION;
           messageObject.Source_System = "Commerce";
           messageObject.Flow = "Product/License Reject";
           messageObject.Screen = "CustomerApprovalPortal";
           messageObject.AgentId = "";
           messageObject.CustomerGuid = _.has(userInfo, "userId") ? userInfo.userId : "";
           messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
           messageObject.approvalId = approvalId;
           messageObject.reason = selectedReason || '';
           messageObject.Result = 'Success';
           LoggerService.saveSplunkLog(messageObject, 'info');

           yield put(getApprovalList(selectedTab));
        }
    }catch(error){
        const messageObject = {};
        messageObject.Message = "Customer rejection of product/license request failed";
        messageObject.Functionality = ACTIVITY.REJECT_REQUEST;
        messageObject.ActivityCategory = ACTIVITY_CATEGORY.ACTION;
        messageObject.Source_System = "Commerce";
        messageObject.Flow = "Product/License Reject";
        messageObject.Screen = "CustomerApprovalPortal";
        messageObject.AgentId = "";
        messageObject.CustomerGuid = _.has(userInfo, "userId") ? userInfo.userId : "";
        messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
        messageObject.approvalId = approvalId;
        messageObject.reason = selectedReason || '';
        messageObject.errorMessage = error && error.message ? error.message : '';
        messageObject.Result = 'Failure';
        LoggerService.saveSplunkLog(messageObject, 'error');
        yield put(showApiErrorMessage(true));
    }

}
